import { StatusOptions } from '@types';

export const MOBILE_SCROLLING_DIV_ID = '_ec_mobile_scrolling_div';
export const DESKTOP_SCROLLING_DIV_ID = '_ec_desktop_scrolling_div';
export const REVIEW_SCROLLING_DIV_ID = '_ec_review_scrolling_div';
export const FOOTER_DIV_ID = '_ec_footer_div';

export const STATUS_OPTIONS: StatusOptions = {
  PENDING: 'pending',
  READY: 'ready_for_evaluation',
  COMPLETE: 'evaluation_complete',
  READY_FOR_SUBMISSION: 'ready_for_submission',
  PENDING_ONBOARDING: 'pending_onboarding',
  USER_ABANDONED: 'user_abandoned',
};
